import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { from, Observable, of, throwError } from 'rxjs';
import { NacoService } from '../domains/services/naco.service';
import { Signature } from '../domains/values/signature';
import { retryWhen, switchMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    public constructor(private naco: NacoService) {}

    public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let needRetry: boolean = true;

        return from(this.naco.getSignature()).pipe(
            switchMap((signature: Signature | null) => {
                if (!signature) {
                    needRetry = false;
                    return next.handle(req);
                }

                return next.handle(
                    req.clone({
                        setHeaders: {
                            Authorization: `${signature.type} ${signature.token}`,
                        },
                    }),
                );
            }),
            retryWhen((error: Observable<HttpErrorResponse>) => {
                return error.pipe(
                    switchMap((err: HttpErrorResponse) => {
                        if (err.status !== 401 || !needRetry) {
                            return throwError(err);
                        }

                        needRetry = false;
                        return this.naco.refreshUser().pipe(
                            switchMap((user: any) => {
                                if (user) {
                                    return of(null);
                                }

                                return throwError(err);
                            }),
                        );
                    }),
                );
            }),
        );
    }
}
